<script lang="ts" setup>
const { t } = useI18n()
const api = useApi()

const { data: response, execute, status } = useAsyncData(
  'doc:utilities-fetch-api-health',
  () => api.utilities.fetchApiHealth(),
  { immediate: false },
)

const endpoints: ApiEndpoint[] = [
  {
    method: 'GET',
    noVersion: true,
    path: '/',
  },
]

const queryAttributes: ApiAttribute[] = []

const responseAttributes: ApiAttribute[] = [
  {
    description: t('response.healthy'),
    name: 'healthy',
    type: 'boolean',
  },
  {
    description: t('response.nodeName'),
    name: 'nodeName',
    type: 'string',
  },
  {
    attributes: [
      {
        attributes: [
          {
            description: t('response.displayName'),
            name: 'displayName',
            type: 'string',
          },
          {
            attributes: [
              {
                description: t('response.healthy'),
                name: 'healthy',
                type: 'boolean',
              },
            ],
            description: t('response.health'),
            name: 'health',
            type: 'object',
          },
        ],
        description: t('response.appKey'),
        name: 'appKey',
        type: 'object',
      },
      {
        attributes: [
          {
            description: t('response.displayName'),
            name: 'displayName',
            type: 'string',
          },
          {
            attributes: [
              {
                description: t('response.healthy'),
                name: 'healthy',
                type: 'boolean',
              },
            ],
            description: t('response.health'),
            name: 'health',
            type: 'object',
          },
        ],
        description: t('response.env'),
        name: 'env',
        type: 'object',
      },
    ],
    description: t('response.report'),
    name: 'report',
    type: 'object',
  },
]

async function onVisibilityChange(visibility: boolean) {
  if (visibility && !response.value) {
    await execute()
  }
}
</script>

<template>
  <ApiDoc
    :endpoints="endpoints"
    :loading="status === 'pending'"
    :query-attributes="queryAttributes"
    :response="response?.data"
    :response-attributes="responseAttributes"
    @visibility-change="onVisibilityChange"
  />
</template>

<i18n lang="json">
{
  "en": {
    "response": {
      "displayName": "Human-readable name of the service.",
      "health": "Health information for the service.",
      "healthy": "Overall health status of the API.",
      "nodeName": "Name of the node responding to the request.",
      "report": "Detailed health report for each service.",
      "serviceHealthy": "Health status of the individual service.",
      "serviceName": "Name of the individual service."
    }
  },
  "es": {
    "response": {
      "displayName": "Nombre legible del servicio.",
      "health": "Información de salud del servicio.",
      "healthy": "Estado de salud general de la API.",
      "nodeName": "Nombre del nodo que responde a la solicitud.",
      "report": "Informe de salud detallado para cada servicio.",
      "serviceHealthy": "Estado de salud del servicio individual.",
      "serviceName": "Nombre del servicio individual."
    }
  },
  "fr": {
    "response": {
      "displayName": "Nom lisible du service.",
      "health": "Informations sur la santé du service.",
      "healthy": "État de santé global de l'API.",
      "nodeName": "Nom du nœud répondant à la requête.",
      "report": "Rapport de santé détaillé pour chaque service.",
      "serviceHealthy": "État de santé du service individuel.",
      "serviceName": "Nom du service individuel."
    }
  }
}
</i18n>
